import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Load } from '~hooks/useLoad/models';
import { dateFormat, formatDuration } from '~utils/dateTime';

interface PickupTimeColumnProps {
  load: Load;
  sx?: SxProps<Theme>;
}

export default function PickupTimeColumn({ load, sx }: PickupTimeColumnProps) {
  return (
    <Box sx={sx}>
      {load.loadSummary?.arrivedPickupAt ? (
        <>
          <OverflowAwareText>
            {dateFormat(load.loadSummary.arrivedPickupAt, 'hh:mm A')}
          </OverflowAwareText>

          <OverflowAwareText sx={(theme) => ({ color: theme.brandV2.colors.treadGray2 })}>
            {load.loadSummary.pickupTimeMinutes
              ? formatDuration(load.loadSummary.pickupTimeMinutes * 60)
              : '0m'}
          </OverflowAwareText>
        </>
      ) : (
        '-'
      )}
    </Box>
  );
}
